export const AccountantManagementEndpoints = {
  listAccess: '/accountant-management/access/list',
  accessExport: '/accountant-management/access/export',
  dashboardMetrics: '/accountant-management/dashboard/invoice/metrics',
  listInvoices: '/accountant-management/dashboard/invoice/list',
  invoicesExport: '/accountant-management/dashboard/invoice/export',
  generateInvoicesPdf: '/accountant-management/dashboard/invoice/generate/pdf',
  generateSpedFiscal: '/accountant-management/dashboard/invoice/generate/sped-fiscal',
  toggleAccessStatus: (id: string) => `/accountant-management/access/status/${id}`,
  removeAccess: (id: string) => `/accountant-management/access/del/${id}`,
  changePassword: (id: string) => `/accountant-management/access/change-password/${id}`,
};
